/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'ng2-breadcrumb/app/components/breadcrumb';
import * as import3 from '@angular/router';
import * as import4 from 'ng2-breadcrumb/app/components/breadcrumbService';
const styles_BreadcrumbComponent:any[] = ([] as any[]);
export const RenderType_BreadcrumbComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_BreadcrumbComponent,
  data: {}
}
);
function View_BreadcrumbComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'role',
        'button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.navigateTo('/')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_BreadcrumbComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'role',
        'button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.navigateTo((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.friendlyName((<any>v.parent).context.$implicit);
    ck(v,1,0,currVal_0);
  });
}
function View_BreadcrumbComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.friendlyName((<any>v.parent).context.$implicit);
    ck(v,1,0,currVal_0);
  });
}
function View_BreadcrumbComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.friendlyName('/');
    ck(v,1,0,currVal_0);
  });
}
function View_BreadcrumbComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'breadcrumb-item',
      'active'
    ]
    ),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.useBootstrap,v.context.last);
    ck(v,1,0,currVal_0);
    const currVal_1:boolean = (!v.context.last && (v.context.$implicit == co.prefix));
    ck(v,6,0,currVal_1);
    const currVal_2:boolean = (!v.context.last && (v.context.$implicit != co.prefix));
    ck(v,9,0,currVal_2);
    const currVal_3:any = v.context.last;
    ck(v,12,0,currVal_3);
    const currVal_4:any = (v.context.last && (v.context.$implicit == co.prefix));
    ck(v,15,0,currVal_4);
  },(null as any));
}
export function View_BreadcrumbComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'ul',([] as any[]),[[
        2,
        'breadcrumb',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_1)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:import2.BreadcrumbComponent = v.component;
    const currVal_1:any = co._urls;
    ck(v,4,0,currVal_1);
  },(ck,v) => {
    var co:import2.BreadcrumbComponent = v.component;
    const currVal_0:any = co.useBootstrap;
    ck(v,1,0,currVal_0);
  });
}
function View_BreadcrumbComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'breadcrumb',([] as any[]),(null as any),(null as any),(null as any),View_BreadcrumbComponent_0,RenderType_BreadcrumbComponent)),
    import0.ɵdid(770048,(null as any),0,import2.BreadcrumbComponent,[
      import3.Router,
      import4.BreadcrumbService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const BreadcrumbComponentNgFactory:import0.ComponentFactory<import2.BreadcrumbComponent> = import0.ɵccf('breadcrumb',import2.BreadcrumbComponent,View_BreadcrumbComponent_Host_0,{
  useBootstrap: 'useBootstrap',
  prefix: 'prefix'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL25nMi1icmVhZGNydW1iL2FwcC9jb21wb25lbnRzL2JyZWFkY3J1bWIubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9ub2RlX21vZHVsZXMvbmcyLWJyZWFkY3J1bWIvYXBwL2NvbXBvbmVudHMvYnJlYWRjcnVtYi50cyIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL25nMi1icmVhZGNydW1iL2FwcC9jb21wb25lbnRzL2JyZWFkY3J1bWIudHMuQnJlYWRjcnVtYkNvbXBvbmVudC5odG1sIiwibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9ub2RlX21vZHVsZXMvbmcyLWJyZWFkY3J1bWIvYXBwL2NvbXBvbmVudHMvYnJlYWRjcnVtYi50cy5CcmVhZGNydW1iQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgICAgIDx1bCBbY2xhc3MuYnJlYWRjcnVtYl09XCJ1c2VCb290c3RyYXBcIj5cbiAgICAgICAgICAgIDxsaSAqbmdGb3I9XCJsZXQgdXJsIG9mIF91cmxzOyBsZXQgbGFzdCA9IGxhc3RcIiBbbmdDbGFzc109XCJ7J2JyZWFkY3J1bWItaXRlbSc6IHVzZUJvb3RzdHJhcCwgJ2FjdGl2ZSc6IGxhc3R9XCI+IDwhLS0gZGlzYWJsZSBsaW5rIG9mIGxhc3QgaXRlbSAtLT5cbiAgICAgICAgICAgICAgICA8YSByb2xlPVwiYnV0dG9uXCIgKm5nSWY9XCIhbGFzdCAmJiB1cmwgPT0gcHJlZml4XCIgKGNsaWNrKT1cIm5hdmlnYXRlVG8oJy8nKVwiPnt7dXJsfX08L2E+XG4gICAgICAgICAgICAgICAgPGEgcm9sZT1cImJ1dHRvblwiICpuZ0lmPVwiIWxhc3QgJiYgdXJsICE9IHByZWZpeFwiIChjbGljayk9XCJuYXZpZ2F0ZVRvKHVybClcIj57e2ZyaWVuZGx5TmFtZSh1cmwpfX08L2E+XG4gICAgICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCJsYXN0XCI+e3tmcmllbmRseU5hbWUodXJsKX19PC9zcGFuPlxuICAgICAgICAgICAgICAgIDxzcGFuICpuZ0lmPVwibGFzdCAmJiB1cmwgPT0gcHJlZml4XCI+e3tmcmllbmRseU5hbWUoJy8nKX19PC9zcGFuPlxuICAgICAgICAgICAgPC9saT5cbiAgICAgICAgPC91bD5cbiAgICAiLCI8YnJlYWRjcnVtYj48L2JyZWFkY3J1bWI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0dnQjtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQWdEO1FBQUE7UUFBQTtNQUFBO01BQWhEO0lBQUE7SUFBMEU7TUFBQTtNQUFBO0lBQUE7SUFBQTs7O0lBQUE7SUFBQTs7Ozs7TUFDMUU7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUFnRDtRQUFBO1FBQUE7TUFBQTtNQUFoRDtJQUFBO0lBQTBFO01BQUE7TUFBQTtJQUFBO0lBQUE7Ozs7SUFBQTtJQUFBOzs7OztJQUMxRTtJQUFtQjtNQUFBO01BQUE7SUFBQTtJQUFBOzs7O0lBQUE7SUFBQTs7Ozs7SUFDbkI7SUFBb0M7TUFBQTtNQUFBO0lBQUE7SUFBQTs7OztJQUFBO0lBQUE7Ozs7O0lBSnhDO2dCQUFBOzs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBK0M7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUE4RDtJQUFtQztJQUM1STtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXFGO0lBQ3JGO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBbUc7SUFDbkc7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUErQztJQUMvQztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWdFOzs7O0lBSnJCO0lBQS9DLFNBQStDLFNBQS9DO0lBQ3FCO0lBQWpCLFNBQWlCLFNBQWpCO0lBQ2lCO0lBQWpCLFNBQWlCLFNBQWpCO0lBQ007SUFBTixVQUFNLFNBQU47SUFDTTtJQUFOLFVBQU0sU0FBTjs7Ozs7SUFOaEI7TUFDUTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBc0M7SUFDbEM7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFLSztJQUNKOzs7O0lBTkc7SUFBSixTQUFJLFNBQUo7OztJQURBO0lBQUosU0FBSSxTQUFKOzs7OztJQ0RSO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/~/ng2-breadcrumb/app/components/breadcrumb.ngfactory.ts